import { Box, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createPlanState } from "../redux/features/createPlanStateSlice";

export const ProductDetails = ({ setIsFormValid, readOnly = false, isFree = false }) => {
  const dispatch = useDispatch();
  const newPlanState = useSelector((state) => state.createPlanState);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(createPlanState({ [name]: value }));
  };

  useEffect(() => {
    const isFormValid = newPlanState.planName && newPlanState.description;
    setIsFormValid(isFormValid);
  }, [newPlanState.planName, newPlanState.description]);

  return (
    <Box
      sx={{
        p: 4,
        borderRadius: 1,
        backgroundColor: "#white",
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        alignItems: "center",
        transition: "opacity 1s ease-in-out",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        height: "auto",
        marginTop: 4,
        width: { xs: "100%", sm: 500 },
      }}
    >
      <Typography textAlign="center" fontWeight="bold" mb={2}>
        Plan Details
      </Typography>
      <Box
        sx={{
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          borderRadius: 1,
          height: "auto",
          padding: "10px",
        }}
      >
        <TextField
          margin="normal"
          required
          id="outlined-helperText"
          label="Plan name"
          name="planName"
          size="small"
          fullWidth
          variant="outlined"
          sx={{
            fontSize: "12px",
          }}
          onChange={handleInputChange}
          value={newPlanState.planName}
          disabled={readOnly}
        />
        { !isFree ? 
        <TextField
        margin="normal"
        required
        id="description"
        label="Description"
        name="description"
        size="small"
        fullWidth
        variant="outlined"
        sx={{
          fontSize: "12px",
        }}
        onChange={handleInputChange}
        value={newPlanState.description}
        disabled={readOnly}
      />
      : <></>
        }
        
      </Box>
    </Box>
  );
};
